import { IconNameT } from '@cad-arc';
import { BoloPanelFormType, CadFeatureMap } from '@mark43/cad-api';
import { FieldPath } from 'react-hook-form';
import { FrBoloDetailsTab } from '../components/tabs/details/fr-bolo-details-tab';
import { FrBoloUpdatesTab } from '../components/tabs/fr-bolo-updates-tab';
import { BoloRelatedDataTab } from '../../bolos/related-data/bolo-related-data-tab';
import { FrBoloAttachmentsTab } from '../components/tabs/fr-bolo-attachments-tab';

export type FrBoloPageTab = 'RELATED_DATA' | 'MEDIA_ATTACHMENTS' | 'BOLO_DETAILS' | 'BOLO_UPDATES';

export type FrBoloPageTabConfigBase = {
    name: string;
    type: FrBoloPageTab;
    icon: IconNameT;
    component: React.FC;
    errorFields?: FieldPath<BoloPanelFormType>[];
    checkEnabled?: (enabledFeatures: CadFeatureMap) => boolean;
};

export const frBoloPageTabConfig: Record<FrBoloPageTab, FrBoloPageTabConfigBase> = {
    BOLO_DETAILS: {
        name: 'BOLO Info',
        type: 'BOLO_DETAILS',
        icon: 'Bolo',
        component: FrBoloDetailsTab,
    },
    BOLO_UPDATES: {
        name: 'Updates',
        type: 'BOLO_UPDATES',
        icon: 'ListViewAlt',
        component: FrBoloUpdatesTab,
    },
    RELATED_DATA: {
        name: 'Related Data',
        type: 'RELATED_DATA',
        icon: 'Document',
        component: BoloRelatedDataTab,
    },
    MEDIA_ATTACHMENTS: {
        name: 'Attachments',
        type: 'MEDIA_ATTACHMENTS',
        icon: 'Paperclip',
        component: FrBoloAttachmentsTab,
        checkEnabled: (enabledFeatures) => enabledFeatures.mediaAttachmentsEnabled,
    },
};
